import ReturnAuthStatusChange from './ReturnAuthStatusChange';
import { FetchReturnAuroraPayInvoice } from './FetchReturnAuroraPayInvoice/FetchReturnAuroraPayInvoice';

export * from './ReturnAuthStatusChange';

export default [
  {
    placement: 'CARD',
    type: 'STATUS_CHANGE',
    component: ReturnAuthStatusChange
  },
  {
    placement: 'CARD',
    type: 'AURORAPAY_INVOICE',
    component: FetchReturnAuroraPayInvoice
  }
];
